import React, { Suspense } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { TabContentSkeleton } from '../components';
import { REPORTING_BASE_PATH } from '../constants';
import type { IReportingOutletProps } from '../interfaces';

const OverviewTab = React.lazy(() => import('../tabs/OverviewTab'));
const RecruitmentFunnelTab = React.lazy(() => import('../tabs/RecruitmentFunnelTab'));
const JobPerformanceTab = React.lazy(() => import('../tabs/JobPerformanceTab'));
const CandidateInsightsTab = React.lazy(() => import('../tabs/CandidateInsightsTab'));
const AssessmentAnalyticsTab = React.lazy(() => import('../tabs/AssessmentAnalyticsTab'));
const HiringOutcomesTab = React.lazy(() => import('../tabs/HiringOutcomesTab'));
const ExportsTab = React.lazy(() => import('../tabs/ExportsTab'));

/** Routed outlet container rendering active reporting tab sub-views. */
export const ReportingOutlet = ({ filters }: IReportingOutletProps) => {
  return (
    <Suspense fallback={<TabContentSkeleton />}>
      <Switch>
        <Route exact path={`${REPORTING_BASE_PATH}/overview`}>
          <OverviewTab filters={filters} />
        </Route>
        <Route exact path={`${REPORTING_BASE_PATH}/recruitment_funnel`}>
          <RecruitmentFunnelTab filters={filters} />
        </Route>
        <Route exact path={`${REPORTING_BASE_PATH}/job_performance`}>
          <JobPerformanceTab filters={filters} />
        </Route>
        <Route exact path={`${REPORTING_BASE_PATH}/candidate_insights`}>
          <CandidateInsightsTab filters={filters} />
        </Route>
        <Route exact path={`${REPORTING_BASE_PATH}/assessment_analytics`}>
          <AssessmentAnalyticsTab filters={filters} />
        </Route>
        <Route exact path={`${REPORTING_BASE_PATH}/hiring_outcomes`}>
          <HiringOutcomesTab filters={filters} />
        </Route>
        <Route exact path={`${REPORTING_BASE_PATH}/exports`}>
          <ExportsTab filters={filters} />
        </Route>
        <Redirect exact from={REPORTING_BASE_PATH} to={`${REPORTING_BASE_PATH}/overview`} />
        <Redirect to={`${REPORTING_BASE_PATH}/overview`} />
      </Switch>
    </Suspense>
  );
};
